import { createFileRoute } from '@tanstack/react-router'
import SolutionsListPage from '@/spa/pages/solutions/SolutionsListPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/solutions/')({
  component: SolutionsListPage,
  errorComponent: routeErrorComponent,
})
